module.exports = __webpack_public_path__ + "media/images/star_on-1f3a4b27035d8237137f50f2657d9555.png";